import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { api, apiError } from "../lib/api";
import { useSeo } from "../lib/seo";

const Done = ({ r }) => (
  <div data-testid="withdrawal-success" className="rounded-3xl bg-white p-6 text-center md:p-8">
    <CheckCircle2 className="mx-auto h-12 w-12 text-[var(--forest)]" />
    <p className="mt-4 font-display text-2xl">{r.existing ? "Ya habías pedido el arrepentimiento" : "Recibimos tu solicitud"}</p>
    <p className="mt-2 text-sm text-[var(--muted-ink)]">Tu número de trámite es</p>
    <p data-testid="withdrawal-tramite" className="mt-1 font-mono text-2xl font-semibold tracking-[0.15em] text-[var(--forest)]">{r.tramite}</p>
    <p className="mt-4 text-sm text-[var(--muted-ink)]">{r.result ? OUTCOME[r.result] : "Te lo enviamos por email y te contactamos ahí."}</p>
  </div>
);

const OUTCOME = {
  reserva_anulada: "Tu reserva no estaba pagada: ya quedó anulada y no tenés que hacer nada más.",
  devolucion_pedida: "Pedimos la devolución de tu pasaje. Te avisamos por email cuando esté hecha.",
  sin_devolucion: "Registramos tu solicitud. Según la anticipación del viaje no corresponde devolución; te contactamos por email.",
  ya_viajo: "Registramos tu solicitud. El pasaje ya fue usado; te contactamos por email.",
  no_aplica: "Registramos tu solicitud. Tu pasaje ya no está activo; te contactamos por email.",
};

export default function Arrepentimiento() {
  useSeo({ title: "Botón de arrepentimiento | Santiagueño", description: "Arrepentite de tu compra online de pasajes: ingresá el código del pasaje y tu email y recibí un número de trámite.", path: "/arrepentimiento" });
  const [f, setF] = useState({ code: "", email: "", reason: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [res, setRes] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const send = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { const { data } = await api.post("/arrepentimiento", f); setRes(data); } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };
  return (
    <>
      <PageHero testid="withdrawal-hero" eyebrow="Botón de arrepentimiento" lines={["Arrepentirme", "de mi compra"]}
        intro="Si compraste online, podés arrepentirte dentro de los 10 días corridos desde la compra. Completá el formulario y te damos un número de trámite. La devolución sigue la misma escala que una devolución común." />
      <section className="bg-[var(--paper)] pb-24">
        <div className="mx-auto max-w-xl px-5 md:px-10">
          {res ? <Done r={res} /> : (
            <form onSubmit={send} data-testid="withdrawal-form" className="space-y-3 rounded-3xl bg-white p-6 md:p-8">
              <Input data-testid="withdrawal-code-input" required minLength={4} placeholder="Código del pasaje (ej. SG-AB12CD)" value={f.code} onChange={set("code")} className="h-12 rounded-xl uppercase" />
              <Input data-testid="withdrawal-email-input" required type="email" placeholder="Email con el que compraste" value={f.email} onChange={set("email")} className="h-12 rounded-xl" />
              <Textarea data-testid="withdrawal-reason-input" maxLength={500} placeholder="Motivo (opcional)" value={f.reason} onChange={set("reason")} className="rounded-xl" />
              {error && <p data-testid="withdrawal-error" className="text-sm text-red-700">{error}</p>}
              <button disabled={loading} data-testid="withdrawal-submit-button" className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-[var(--forest)] font-bold text-white disabled:opacity-50">
                {loading && <Loader2 className="h-4 w-4 animate-spin" />} Enviar solicitud de arrepentimiento
              </button>
              <p className="text-xs text-[var(--muted-ink)]">Más información en <Link to="/cambios-y-devoluciones" className="font-semibold text-[var(--forest)] underline">Cambios y devoluciones</Link>.</p>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
